export const model = {
    id: null,
    name: "",
    file: "",
    category_id: null,
    created_at: '',
    updated_at: ''
};
